export const isUnauthorized = (errors) => {
  return errors.some(
    (error) => error?.extensions?.exception?.info?.statusCode === 401
  );
};

export const notGuestPath = () =>
  window.location.pathname !== "/login" &&
  !window.location.pathname.includes("/reset") &&
  !window.location.pathname.includes("/guest");
